export default __webpack_public_path__ + "static/media/DinosaursHerbivores_09.15031ab2.png";